<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Master Charts</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    [mat-dialog-close]="false"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="p-0">
  <mat-tab-group [selectedIndex]="selectedTabIndex">

    <mat-tab label="Account Inductions">
      <ng-template matTabContent>
        <div class="px-3 pt-0 pb-3">
          <app-inductions-charts-container [baseStorageKey]="'master-inductions'" [disableExpansionPanel]="true" [enable_realtime_data]="enable_realtime_data" [realtime_data_interval_seconds]="realtime_data_interval_seconds" [query_type]="query_type"></app-inductions-charts-container>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab label="Forms">
      <ng-template matTabContent>
        <div class="px-3 pt-0 pb-3">
          <app-dynamic-forms-charts-container [baseStorageKey]="'master-forms'" [disableExpansionPanel]="true" [enable_realtime_data]="enable_realtime_data" [realtime_data_interval_seconds]="realtime_data_interval_seconds" [query_type]="query_type"></app-dynamic-forms-charts-container>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab label="Hazards & Risks">
      <ng-template matTabContent>
        <div class="px-3 pt-0 pb-3">
          <app-hazards-charts-container [baseStorageKey]="'master-hazards'" [disableExpansionPanel]="true" [enable_realtime_data]="enable_realtime_data" [realtime_data_interval_seconds]="realtime_data_interval_seconds" [query_type]="query_type"></app-hazards-charts-container>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab label="Incidents">
      <ng-template matTabContent>
        <div class="px-3 pt-0 pb-3">
          <app-incidents-charts-container [baseStorageKey]="'master-incidents'" [disableExpansionPanel]="true" [enable_realtime_data]="enable_realtime_data" [realtime_data_interval_seconds]="realtime_data_interval_seconds" [query_type]="query_type"></app-incidents-charts-container>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab label="Inspections & Audits">
      <ng-template matTabContent>
        <div class="px-3 pt-0 pb-3">
          <app-site-audits-charts-container [baseStorageKey]="'master-site-audits'" [disableExpansionPanel]="true" [enable_realtime_data]="enable_realtime_data" [realtime_data_interval_seconds]="realtime_data_interval_seconds" [query_type]="query_type"></app-site-audits-charts-container>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab label="Messages">
      <ng-template matTabContent>
        <div class="px-3 pt-0 pb-3">
          <app-messages-charts-container [baseStorageKey]="'master-messages'" [disableExpansionPanel]="true" [enable_realtime_data]="enable_realtime_data" [realtime_data_interval_seconds]="realtime_data_interval_seconds" [query_type]="query_type"></app-messages-charts-container>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab label="Safety Observations">
      <ng-template matTabContent>
        <div class="px-3 pt-0 pb-3">
          <app-safety-observations-charts-container [baseStorageKey]="'master-safety-observations'" [disableExpansionPanel]="true" [enable_realtime_data]="enable_realtime_data" [realtime_data_interval_seconds]="realtime_data_interval_seconds" [query_type]="query_type"></app-safety-observations-charts-container>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab label="Access Activities">
      <ng-template matTabContent>
        <div class="px-3 pt-0 pb-3">
          <app-site-access-activities-charts-container [baseStorageKey]="'master-access-activities'" [disableExpansionPanel]="true" [enable_realtime_data]="enable_realtime_data" [realtime_data_interval_seconds]="realtime_data_interval_seconds" [query_type]="query_type"></app-site-access-activities-charts-container>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab [label]="utils.getLangTerm('parent-child-sites-combined.plural', 'Sites')">
      <ng-template matTabContent>
        <div class="px-3 pt-0 pb-3">
          <app-sites-charts-container [baseStorageKey]="'master-sites'" [disableExpansionPanel]="true" [enable_realtime_data]="enable_realtime_data" [realtime_data_interval_seconds]="realtime_data_interval_seconds" [query_type]="query_type"></app-sites-charts-container>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab label="Tasks">
      <ng-template matTabContent>
        <div class="px-3 pt-0 pb-3">
          <app-tasks-charts-container [baseStorageKey]="'master-tasks'" [disableExpansionPanel]="true" [enable_realtime_data]="enable_realtime_data" [realtime_data_interval_seconds]="realtime_data_interval_seconds" [query_type]="query_type"></app-tasks-charts-container>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab [label]="utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks')">
      <ng-template matTabContent>
        <div class="px-3 pt-0 pb-3">
          <app-toolbox-talks-charts-container [baseStorageKey]="'master-toolbox-talks'" [disableExpansionPanel]="true" [enable_realtime_data]="enable_realtime_data" [realtime_data_interval_seconds]="realtime_data_interval_seconds" [query_type]="query_type"></app-toolbox-talks-charts-container>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<!--<mat-dialog-actions class="d-flex justify-content-end">-->

<!--</mat-dialog-actions>-->
